module.exports = __webpack_public_path__ + "static/media/instance_icon_dashboard.bd6680fd.svg";